import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-toppur',
  templateUrl: './toppur.component.html',
  styleUrls: ['./toppur.component.css']
})
export class ToppurComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
